"use strict";
var __importDefault = (this && this.__importDefault) || function (mod) {
    return (mod && mod.__esModule) ? mod : { "default": mod };
};
Object.defineProperty(exports, "__esModule", { value: true });
const jsx_runtime_1 = require("react/jsx-runtime");
const react_query_1 = require("@tanstack/react-query");
const react_1 = require("react");
const react_router_1 = require("react-router");
const teamQuery_1 = require("../../../../queries/teamQuery");
const zustandStore_1 = require("../../../../zustandStore");
const simpleHeader_1 = __importDefault(require("../../../organisms/header/simpleHeader"));
const people_1 = __importDefault(require("../../../templates/teamSettings/people"));
const useTeamsState_1 = require("../overview/hooks/useTeamsState");
const TeamSettingsPeoplePage = () => {
    const initialData = (0, react_router_1.useLoaderData)();
    const { data: teamId } = (0, react_query_1.useQuery)({
        ...(0, teamQuery_1.selectedTeamIdQuery)('selectedTeamID'),
        initialData: initialData.teamId,
    });
    const { data: team } = (0, react_query_1.useQuery)({
        ...(0, teamQuery_1.teamQuery)({ teamId: teamId?.[0] || '' }),
    });
    const state = (0, useTeamsState_1.useTeamsState)();
    const { setHeaderName, setTeamName } = (0, zustandStore_1.useZustand)();
    (0, react_1.useEffect)(() => {
        if (team) {
            state.setTeam(team);
        }
    }, [state.setTeam, team]);
    (0, react_1.useEffect)(() => {
        if (team?.name) {
            const name = team.name;
            setTeamName(name);
            setHeaderName(name);
        }
    }, [team]);
    return ((0, jsx_runtime_1.jsxs)(jsx_runtime_1.Fragment, { children: [(0, jsx_runtime_1.jsx)(simpleHeader_1.default, {}), (0, jsx_runtime_1.jsx)(people_1.default, {})] }));
};
exports.default = TeamSettingsPeoplePage;
